import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import NotificationCentreActions, { notificationCentreActionTypes } from '../../actions/configurations/notificationCentreActions';
import NotificationCentreService from '../../services/configurations/notificationCentreService';

function* _getNotifications(action) {
  try {
    yield put(NotificationCentreActions.getNotificationLoading(true));
    const { payload, callback } = action;
    const notify = yield NotificationCentreService.getNotifications(payload);
    if (!notify.success) {
      notification.open({
        type: 'error',
        message: notify?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      if (callback) callback(notify?.result);
      yield put(NotificationCentreActions.getNotificationSuccess(notify?.result));
    }
    yield put(NotificationCentreActions.getNotificationLoading(false));
  } catch (error) {
    yield put(NotificationCentreActions.getNotificationLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getNotifications() {
  yield takeLatest(notificationCentreActionTypes.GET_NOTIFICATION.REQUEST, _getNotifications);
}

function* _updateNotifications(action) {
  try {
    yield put(NotificationCentreActions.updateNotificationLoading(true));
    const { payload, callback } = action;
    const notifyName = payload?.notify_name;
    const notifyUpdate = yield NotificationCentreService.updateNotifications(payload);
    if (notifyUpdate.success) {
      notification.open({
        type: 'success',
        message: `${notifyName?.toProperCase()} notification updated successfully`,
        duration: 2,
        placement: 'top',
      });
      if (callback) callback();
      yield put(NotificationCentreActions.updateNotificationLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: notifyUpdate?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(NotificationCentreActions.updateNotificationLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(NotificationCentreActions.updateNotificationLoading(false));
  }
}

function* updateNotifications() {
  yield takeLatest(notificationCentreActionTypes.UPDATE_NOTIFICATION.REQUEST, _updateNotifications);
}

export default function* notificationCentreSaga() {
  yield all([
    getNotifications(),
    updateNotifications(),
  ]);
}
